import { Cache, DataStore, DataStoreOptions } from '@skinsoft/data-store';
import { TranslatedString } from '@skinsoft/i18n';
import { Proxy } from '@skinsoft/network';

export interface RecordMaskField {
    columnDisplay: boolean | null,
    entityField: any
    entityFields: any[] | null
    fieldFormat: any
    formatter: any
    inputComponent: any
    mandatoryUser: boolean
    order: number
    tableDisplay: any
    paginated?: boolean | null,
    applyAutomaticFormat?: boolean
}

export interface RecordMaskCategory {
    label: any,
    maskFields: RecordMaskField[]
}

export interface RecordMask {
    id: string,
    level: string,
    userId: string,
    isInputMask: boolean,
    categoriesDisplay: any,
    categories: RecordMaskCategory[],
    name: any
    workspaceCreation: string,
    workspaceSharing: any[],
    _links?: any

    // for meta mask
    entities?: any[],
    target?: any,

    // for mask
    entityTargetId?: string,
    entityTarget?: string,
    isPatternMask?: boolean,
    pattern?: null,
}

export class RecordMaskDataStore extends DataStore<RecordMask> {

    public static getInstance() {
        if (!RecordMaskDataStore.instance) {
            RecordMaskDataStore.instance = new RecordMaskDataStore();
        }

        return RecordMaskDataStore.instance;
    }

    public static install(Vue) {
        Vue.prototype.$recordMaskDataStore = RecordMaskDataStore.getInstance();
    }

    private static instance: RecordMaskDataStore = null as any;

    constructor(proxy?: Proxy, cache?: Cache<RecordMask>) {
        super(`/record-masks`);
    }

    // @ts-ignore
    public searchAll(queryText: string, sortObject: any, pageSize: number) {
        throw new Error("This method is not implemented in this subclass")
    }
}